const OffersBlue = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_2701_52214)">
      <path
        d="M16 7.99832C16 8.78584 14.5085 9.32808 14.2779 10.0386C14.0389 10.7751 14.9187 12.0887 14.4728 12.7017C14.0222 13.3209 12.4981 12.8878 11.879 13.3383C11.2661 13.7844 11.2093 15.37 10.4728 15.609C9.76224 15.8396 8.78752 14.5974 8 14.5974C7.21264 14.5974 6.23792 15.8394 5.52736 15.6087C4.79104 15.3697 4.7344 13.7839 4.12144 13.3378C3.5024 12.8873 1.97824 13.3204 1.52768 12.7014C1.0816 12.0884 1.96128 10.7748 1.72224 10.0385C1.49152 9.32792 0 8.786 0 7.99832C0 7.21096 1.49152 6.66904 1.7224 5.95848C1.9616 5.22216 1.08208 3.90856 1.52816 3.2956C1.97872 2.67656 3.50288 3.10968 4.12192 2.65912C4.73488 2.21304 4.7912 0.627275 5.52736 0.388076C6.23792 0.157356 7.21264 1.39944 8 1.39944C8.78752 1.39944 9.76224 0.157356 10.4726 0.387916C11.2091 0.626956 11.2656 2.21272 11.8786 2.6588C12.4976 3.10936 14.0218 2.6764 14.4723 3.29544C14.9184 3.9084 14.0387 5.222 14.2778 5.95832C14.5085 6.66904 16 7.21096 16 7.99832Z"
        fill="url(#paint0_linear_2701_52214)"
      />
      <path
        d="M10.6598 9.15238C11.0614 9.55398 11.0614 10.2068 10.6598 10.6084V10.61C10.5334 10.7364 10.3814 10.8244 10.2214 10.8708C10.1254 10.8996 10.0246 10.914 9.92544 10.914C9.88864 10.914 9.85344 10.9124 9.81824 10.9076C9.78304 10.9044 9.74784 10.8996 9.71264 10.8916C9.52384 10.8516 9.34464 10.7588 9.19904 10.6132C8.79744 10.2116 8.79744 9.55878 9.20384 9.15238C9.35104 9.00518 9.52864 8.91398 9.71744 8.87398H9.71904C9.72544 8.87238 9.73184 8.87078 9.73824 8.87078C9.77024 8.86438 9.80064 8.85958 9.83264 8.85638C9.86464 8.85318 9.89664 8.85158 9.92864 8.85158C10.1926 8.84998 10.4582 8.94918 10.6598 9.15238Z"
        fill="url(#paint1_linear_2701_52214)"
      />
      <path
        d="M5.35529 6.77724C4.95369 6.37564 4.95369 5.72284 5.36009 5.31644C5.50729 5.16924 5.68649 5.07644 5.87529 5.03804C5.88009 5.03644 5.88649 5.03484 5.89129 5.03484C5.92329 5.02844 5.95689 5.02364 5.98889 5.02044C6.02089 5.01724 6.05289 5.01564 6.08489 5.01564C6.34889 5.01404 6.61449 5.11324 6.81609 5.31644C7.21769 5.71804 7.21769 6.36924 6.81609 6.77244V6.77404C6.68969 6.90044 6.53769 6.98844 6.37769 7.03484C6.28169 7.06364 6.18089 7.07804 6.08169 7.07804C6.04489 7.07804 6.00969 7.07644 5.97449 7.07164C5.93769 7.06844 5.90409 7.06364 5.86889 7.05564C5.68009 7.01564 5.50089 6.92284 5.35529 6.77724Z"
        fill="url(#paint2_linear_2701_52214)"
      />
      <path
        d="M10.8525 5.84148L5.88133 10.8143C5.78053 10.9135 5.64773 10.9647 5.51813 10.9647C5.38373 10.9647 5.25413 10.9135 5.15013 10.8143C5.11653 10.7759 5.08613 10.7359 5.06213 10.6943C4.95653 10.4991 4.98533 10.2479 5.15013 10.0831L10.1229 5.11188C10.2877 4.94548 10.5373 4.91828 10.7341 5.02228C10.7757 5.04628 10.8157 5.07668 10.8525 5.11188C11.0541 5.31508 11.0541 5.64148 10.8525 5.84148Z"
        fill="url(#paint3_linear_2701_52214)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2701_52214"
        x1="2.87376"
        y1="2.87208"
        x2="12.7734"
        y2="12.7718"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18A1EB" />
        <stop offset="1" stopColor="#0527CF" stopOpacity="0.76" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2701_52214"
        x1="9.20144"
        y1="9.15478"
        x2="10.6582"
        y2="10.6116"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBF4F5" />
        <stop offset="1" stopColor="#B5C6E0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2701_52214"
        x1="5.35769"
        y1="5.31884"
        x2="6.81449"
        y2="6.77564"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBF4F5" />
        <stop offset="1" stopColor="#B5C6E0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2701_52214"
        x1="6.31077"
        y1="6.27252"
        x2="9.70485"
        y2="9.6666"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F5EFEB" />
        <stop offset="1" stopColor="#E0CAB5" />
      </linearGradient>
      <clipPath id="clip0_2701_52214">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default OffersBlue;
